/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'identification': {
    width: 60,
    height: 40,
    viewBox: '0 0 60 40',
    data: '<rect pid="0" width="60" height="40" rx="6" _fill="#62E2AA"/><rect pid="1" x="8" y="18" width="10" height="10" rx="2" transform="rotate(-90 8 18)" _fill="#2E48DA"/><rect pid="2" x="8" y="22" width="26" height="3" rx="1.5" _fill="#2E48DA"/><rect pid="3" x="8" y="29" width="26" height="3" rx="1.5" _fill="#2E48DA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/identification.js